import React, { Component } from 'react';
import { connect } from 'react-redux'
import { selectKreis as selectKreisAction} from '../actions/kreise'
import KreiseSelectComponent from '../components/KreiseSelect'

class KreiseSelect extends Component
{
    render(){
        return <KreiseSelectComponent kreise={this.props.kreise} selected={this.props.selected} selectKreis={this.selectKreis.bind(this)}/>
    }

    selectKreis(kvnr) {
        this.props.dispatch(selectKreisAction(kvnr));
    }
}

const mapStateToProps = store=>{
    let bezirk = store.bezirke.selected;
    let kreise = null;
    if (bezirk) {
        kreise = store.kreise.list[bezirk];
    }
    return {
        kreise,
        selected: store.kreise.selected
    }
}

export default connect(mapStateToProps)(KreiseSelect)


// WEBPACK FOOTER //
// ./src/containers/KreiseSelect.js